import React from "react";
import { ToastContainer, toast } from "react-toastify";
import {deleteServiceRequest} from "../../utilities/ServiceRequestAPI";
import keycloak from "../../Keycloak";

const showCancelSuccess = () => {
    toast.success("Successfully deleted", {
        position: toast.POSITION.TOP_LEFT,
        style: {
            backgroundColor: "#49c96d",
            width: "650px",
            color: "#FFFFFF",
            left: "400px",
            theme: "light",
        },
        onClose: () => {
            window.location.reload();
        }
    });
    document.getElementById("AllClientsDiv").style.display = "none";
    document.getElementById("clientNameTextBox2").style.display = "none";
};

let paramToChange;
let action;

const DeleteServiceRequest = ({ open, onClose }) => {
    if (!open) return null;

    if (window.location.href.includes("/ServiceRequestList")  || window.location.href.includes("/ServiceRequest") || window.location.href.includes("/EditServiceRequest")) {
        paramToChange = "Delete Service Request"
        action = "delete service request"
        window.scrollTo(0, 0);
    }
    else if(window.location.href.includes("/ClientServiceRequestList"))
    {
        paramToChange = "Delete Service Request"
        action = "delete service request"
    }

    const handleClick = (e) => {
        const fetchData = async () => {
            try {
                const serviceRequestId = localStorage.getItem('serviceRequestListSelectedServiceRequestId');
                await deleteServiceRequest(serviceRequestId, keycloak.token);
                onClose();
                showCancelSuccess();
            }
            catch (error){
                console.error(error);
            }
        }
        fetchData();
    }


    return (
        <div className={"overlay"}>
            <ToastContainer newestOnTop={true} />
            <div className="overlayMain">
                <div className="modalContainer">
                    <div className="content">
                        <h3>{paramToChange}</h3>
                        <br></br>
                        <p>Are you sure you want to {action}?</p>
                    </div>
                    <div className="btnContainer">
                        <button data-testid={"deleteServiceRequestYes"}
                            className="btnPrimary"
                            // onClick={() => {
                            //     showCancelSuccess();
                            //     navigate(path, { state: { showToast: true } });
                            //     onClose();
                            // }}
                            onClick={handleClick}
                        >
                            <span>YES</span>
                        </button>
                        <button data-testid={"cancelServiceRequestDelete"} className="btnSecondary" onClick={onClose}>
                            NO
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeleteServiceRequest;
